<template>
  <el-container class="StockForm">
    <el-main class="p-0">
      <el-form
        ref="form"
        class="form-label-80"
        label-width="80px"
        :model="data"
        :rules="rules"
        :inline="false"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="품목구분" prop="type_id">
              <AProductTypeSelector v-model="data.type_id" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('lang.material_name')" prop="name">
              <el-input
                v-model="data.name"
                :placeholder="$t('lang.material_name')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$t('lang.sales_classification')"
              prop="sale_type_id"
            >
              <el-select
                v-model="data.sale_type_id"
                :placeholder="$t('lang.sales_classification')"
              >
                <el-option
                  v-for="item in table_sale_type"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('lang.code')" prop="code">
              <el-input v-model="data.code" :placeholder="$t('lang.code')" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('lang.unit')" prop="unit_id">
              <div class="inline">
                <el-select
                  v-model="data.unit_id"
                  :placeholder="$t('lang.unit')"
                  @change="handleChangeUnit"
                >
                  <el-option
                    v-for="item in unit_items"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
              <div class="inline ml-default" v-if="isWeight">
                <ACheckboxYN v-model="data.size_amount_flag">
                  규격수량
                </ACheckboxYN>
                <ANumberInput
                  v-model="data.size_amount"
                  class="ml-default"
                  style="width: 100px;"
                  allowDecimal
                />
                <AHelper>
                  수주/매출 등록시 규격이 수량으로 적용됩니다.<BR />
                  알루미늄처럼 자재는 중량으로 관리하고<BR /> 수주는 길이로
                  관리하는 경우 설정해 주세요.<BR />
                  변환값에는 규격 1당 g 값을 입력해 주세요.
                </AHelper>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="규격" prop="size">
              <el-input
                v-model="data.size"
                clearable
                maxlength="100"
                placeholder="규격"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="제품구분" prop="categories">
              <el-select
                v-model="data.categories"
                multiple
                :placeholder="$t('lang.categories')"
              >
                <el-option
                  v-for="item in table_product_category"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="13">
            <el-form-item label="구분">
              <el-radio-group v-model="data.kind">
                <el-radio-button :label="null">없음</el-radio-button>
                <el-radio-button label="GOODS">
                  기계
                  <AHelper type="warning"
                    >수주시 제품번호가 생성됩니다.</AHelper
                  >
                </el-radio-button>
                <el-radio-button label="GLASS">
                  유리
                  <AHelper type="warning"
                    >수주시 규격(가로*세로)으로 평을 계산하고 평당 단가가
                    계산됩니다.</AHelper
                  >
                </el-radio-button>
                <el-radio-button label="DOOR">
                  도어
                  <AHelper type="warning"
                    >수주시 조립여부를 설정합니다.</AHelper
                  >
                </el-radio-button>
                <el-radio-button label="SERIAL">
                  품번관리
                  <AHelper type="warning"
                    >수주시 제품번호가 생성됩니다.</AHelper
                  >
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="3">
            <el-form-item label="유리">
              <ACheckboxYN 
                v-model="data.glass_flag"
                :disabled="data.goods_flag === 'Y' || data.serial_flag === 'Y'"
              />
              <AHelper>수주시 규격(가로*세로)으로 평을 계산하고 평당 단가가 계산됩니다.</AHelper>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="기계">
              <ACheckboxYN 
                v-model="data.goods_flag"
                :disabled="data.glass_flag === 'Y' || data.serial_flag === 'Y'"
              />
              <AHelper>수주시 제품번호가 생성됩니다.</AHelper>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="품번관리">
              <ACheckboxYN 
                v-model="data.serial_flag"
                :disabled="data.glass_flag === 'Y' || data.goods_flag === 'Y'"
              />
              <AHelper>품목에 대한 품번을 관리합니다.</AHelper>
            </el-form-item>
          </el-col> -->
          <el-col :span="5">
            <el-form-item label="품번코드">
              <el-input
                v-model="data.prefix_code"
                maxlength="10"
                :disabled="!['GOODS', 'SERIAL'].includes(data.kind)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="매입원가">
              <el-input v-model="data.purchase_cost" maxlength="10" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="14">
            <el-form-item label="이미지">
              <div class="flex">
                <div>
                  <el-upload
                    action="#"
                    :show-file-list="false"
                    :auto-upload="false"
                    :on-change="handleOnChange"
                  >
                    <el-button type="info">이미지 파일</el-button>
                  </el-upload>
                </div>
                <div class="ml-default">
                  <div v-if="temp_image_name">
                    <span>{{ temp_image_name }}</span>
                    <span class="ml-default">
                      <el-button @click="handleClickRemoveTempImage"
                        >취소</el-button
                      >
                    </span>
                  </div>
                  <div v-else-if="data.image_name">
                    <span>{{ data.image_name }}</span>
                    <span class="ml-default">
                      <ACheckboxYN v-model="delete_image">삭제</ACheckboxYN>
                    </span>
                  </div>
                </div>
                <div v-if="check_image_name_includes_korean">
                  <AHelper type="warning" />&nbsp;
                  <span :style="{ color: '#E6A23C' }"
                    >한글명이 포함된 이미지는 업로드 할 수 없습니다.</span
                  >
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="사용">
              <ACheckboxYN v-model="data.use_flag" />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="재고관리">
              <ACheckboxYN v-model="data.is_manage_stock" />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="숨기기">
              <ACheckboxYN v-model="data.is_hide" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="23">
            <el-form-item :label="$t('lang.desc')" class="custom-form-item">
              <el-input
                v-model="data.desc"
                clearable
                maxlength="100"
                :placeholder="$t('lang.desc')"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <el-footer :style="{ display: 'flex', alignItems: 'center' }">
      <el-button
        type="primary"
        v-shortkey="['F4']"
        :disabled="!has_grant_write"
        :loading="load_button"
        @shortkey.native="clickSave"
        @click="clickSave"
        >{{
          isNew ? $t("button.register") : $t("button.modify")
        }}(F4)</el-button
      >
      <el-button
        v-if="data.is_manage_stock === 'Y' && data.bom_flag === 'Y' && data.id"
        :style="{ padding: '4px 10px' }"
        :disabled="!has_grant_write"
        :loading="load_button"
        @click="openMessageBox"
        >BOM 하위 품목 재고 관리 설정
        <!-- clickSetSubItemManageStock -->
        <AHelper
          v-if="data.is_manage_stock === 'Y' && data.bom_flag === 'Y'"
          type="warning"
          >저장하는 기능 또한 수행됩니다.</AHelper
        >
      </el-button>
      <el-button
        type="danger"
        v-if="!isNew"
        :disabled="!has_grant_write"
        :loading="load_button"
        @click="clickDel"
        >{{ $t("button.delete") }}</el-button
      >

      <el-button class="close-button" @click="closeDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
    <el-dialog
      custom-class="el-dialog-headless"
      width="400px"
      title="BOM 하위 품목 재고 관리 설정"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-radio v-model="sub_item_manage_stock" label="Y">설정</el-radio>
      <el-radio v-model="sub_item_manage_stock" label="N">해제</el-radio>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="clickSetSubItemManageStock"
          >저장</el-button
        >

        <el-button @click="innerVisible = false">닫기(Esc)</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";

export default {
  name: "ProductForm",
  mixins: [form],
  data() {
    let validateSizeUnit = (rule, value, callback) => {
      if (this.data.size_amount_flag !== "Y") {
        callback();
      } else {
        if (!this.data.size_amount) {
          callback(new Error("단위변환값을 입력해 주세요."));
        } else {
          callback();
        }
      }
    };
    return {
      title: this.$t("lang.title_product"),
      rules: {
        type_id: [
          {
            required: true,
            message: "품목구분을 선택하세요.",
            trigger: "change",
          },
        ],
        name: [
          { required: true, message: "품목명을 입력하세요.", trigger: "blur" },
        ],
        sale_type_id: [
          {
            required: true,
            message: "판매구분을 선택하세요.",
            trigger: "change",
          },
        ],
        unit_id: [
          { required: true, message: "단위를 선택하세요.", trigger: "change" },
          { validator: validateSizeUnit, trigger: ["blur", "change"] },
        ],
      },
      temp_image_name: "",
      temp_image: null,
      delete_image: "N",
      load_button: false,
      check_image_name_includes_korean: false,
      innerVisible: false,
      sub_item_manage_stock: "N",
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          type_id: 1,
          name: "",
          categories: [],
          options1: [],
          options2: [],
          use_flag: "Y",
          sale_type_id: 1,
          unit_id: 1,
          size_amount_flag: "N",
          size_amount: null,
          desc: "",
          // serial_flag: 'N',
          kind: null,
          purchase_cost: 0,
        };
      },
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "table_product",
      "table_product_category",
      "table_unit",
      "table_sale_type",
    ]),
    /** 신규 여부 */
    isNew: function() {
      return this.data.id < 1;
    },
    unitName: function() {
      let unit = this.table_unit.find((u) => u.id === this.data.unit_id);
      return unit ? unit.name : "";
    },
    isWeight() {
      return this.unitName === "g" || this.unitName === "kg";
    },
    unit_items() {
      let items = this.table_unit;
      items.sort((a, b) => a.seq - b.seq);
      return items;
    },
  },
  watch: {
    temp_image_name(data) {
      const check = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
      this.check_image_name_includes_korean = check.test(data);
    },
  },
  methods: {
    /** BOM 하위 품목 재고 관리 설정  */
    clickSetSubItemManageStock() {
      this.api
        .updateSubItemManageStock({
          ...this.data,
          sub_item_manage_stock: this.sub_item_manage_stock,
        })
        .then((res) => {
          this.load_button = false;
          if (res.error !== this.system.noError) {
            this.util.notify_response_error(this, this.title, res);
            return;
          }
          this.util.notify_success(this, this.title, "적용되었습니다.");
          this.innerVisible = false;
        });
    },
    /** 등록 or 수정 */
    clickSave() {
      if (!this.has_grant_write) return;

      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.doSave();
      });
    },
    /** 삭제 */
    clickDel() {
      this.util.confirm_delete(
        this,
        "품목[" + this.data.name + "]",
        this.doDelete
      );
    },
    /** 데이터 값 정리 */
    organizeData() {
      let data = Object.assign({}, this.data);
      for (let i = 0; i < data.categories.length; i++) {
        let obj = {};
        obj.product_category_id = Object.assign(data.categories[i]);
        data.categories[i] = obj;
      }
      if (this.temp_image) {
        data.temp_image_name = this.temp_image_name;
        data.temp_image = this.temp_image;
      } else {
        if (this.delete_image === "Y") {
          data.image_name = null;
          data.delete_image = "Y";
        }
      }
      return data;
    },
    doSave() {
      const data = this.organizeData();
      if (data.code) {
        data.code = data.code.trim();
      }
      if (data.code) {
        let duplicate = this.table_product.find(
          (p) => p.id !== data.id && p.code === data.code
        );
        if (duplicate) {
          this.util.notify_warning(this, this.title, "중복된 코드입니다");
          return;
        }
      }
      if (this.check_image_name_includes_korean) {
        this.$alert(
          "한글명이 포함된 이미지는 업로드 할 수 없습니다.",
          "이미지 저장 오류",
          {
            type: "warning",
          }
        );
        return;
      }
      this.load_button = true;
      if (this.isNew) {
        data.code = undefined;
        this.api.createProduct(data).then((res) => {
          this.load_button = false;
          this.handleResult(res, "create", "등록되었습니다.");
        });
      } else {
        this.api.updateProduct(data).then((res) => {
          this.load_button = false;
          this.handleResult(res, "update", "수정되었습니다.");
        });
      }
    },
    doDelete() {
      this.load_button = true;
      this.api.deleteProduct(this.data).then((res) => {
        this.load_button = false;
        this.handleResult(res, "delete", "삭제되었습니다.");
      });
    },

    /** 닫기 */
    closeDialog() {
      this.$emit("completed");
    },

    /** noti 옵션 반환 */
    getNotifyOptions(message) {
      return this.util.get_notify_options(
        "s",
        this.$t("lang.title_product"),
        message
      );
    },
    handleChangeUnit() {
      if (!this.isWeight) {
        this.data.size_amount_flag = "N";
      }
    },
    handleResult(res, action, message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, message);
      this.$emit("completed");
    },
    handleOnChange(event) {
      const file = event.raw;
      this.temp_image_name = file.name;
      const reader = new FileReader();
      reader.onload = this.loadImage;
      reader.readAsDataURL(file);
    },
    loadImage(e) {
      let image = e.target.result;
      if (image.substring(0, 10) !== "data:image") {
        this.temp_image_name = "";
        this.temp_image = null;
        this.util.notify_error(this, this.title, "이미지 파일이 아닙니다.");
        return;
      }
      this.temp_image = image;
    },
    handleClickRemoveTempImage() {
      this.temp_image_name = "";
      this.temp_image = null;
    },
    openMessageBox() {
      this.innerVisible = true;
    },
  },
};
</script>
<style>
.el-dialog-headless > .el-dialog__header {
  border-bottom: none;
}
</style>
